import numberFormats from './numberFormats.utils.js';

/* Set application language from localStorage  */
const defaultLangCode = 'en';
const langCodeKey = 'PixLanguageCode';
const langCode = JSON.parse(localStorage.getItem(langCodeKey)) || defaultLangCode;

// Create VueI18n instance options
const i18nOptions = {
  langCodeKey,
  locale: langCode, // set locale
  fallbackLocale: defaultLangCode, // fallback in case not found.
  messages: {}, // set locale messages
  numberFormats, // set locale number formattings
};

export default i18nOptions;
